module.exports = __webpack_public_path__ + "img/fair.2ffee699.png";